import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VResponsive } from 'vuetify/lib/components/VResponsive';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VResponsive,
    {
      attrs: {
        "max-width": _vm.$attrs["max-width"],
        "max-height": _vm.$attrs["max-height"],
        "min-width": _vm.$attrs["min-width"],
        "min-height": _vm.$attrs["min-height"],
      },
    },
    [
      _c(
        VImg,
        _vm._g(
          _vm._b(
            {
              key: _vm.retryCounter,
              class: _vm.imageClass,
              attrs: {
                src: _vm.imageSrc,
                contain: _vm.noImage || _vm.$attrs.contain,
                "lazy-src": require("@/assets/images/spinner.svg"),
              },
              on: { error: _vm.onError, contextmenu: _vm.onContextMenu },
              scopedSlots: _vm._u(
                [
                  _vm.enableLoad && _vm.$slots.loader
                    ? {
                        key: "placeholder",
                        fn: function () {
                          return [_vm._t("loader")]
                        },
                        proxy: true,
                      }
                    : null,
                ],
                null,
                true
              ),
            },
            "v-img",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [_vm._v(" "), _vm._t("content")],
        2
      ),
      _vm._v(" "),
      _c(
        VMenu,
        {
          attrs: {
            "position-x": _vm.mouseX,
            "position-y": _vm.mouseY,
            absolute: "",
            "offset-y": "",
            "close-on-click": "",
          },
          model: {
            value: _vm.showMenu,
            callback: function ($$v) {
              _vm.showMenu = $$v
            },
            expression: "showMenu",
          },
        },
        [
          _c(
            VList,
            _vm._l(_vm.imageMenuList, function (menuItem, index) {
              return _c(
                VListItem,
                {
                  key: index,
                  on: {
                    click: function ($event) {
                      return menuItem.menuFunction(_vm.imageSrc)
                    },
                  },
                },
                [
                  _c(
                    VListItemAvatar,
                    [
                      _c(VIcon, [
                        _vm._v(
                          "\n            " +
                            _vm._s(menuItem.icon) +
                            "\n          "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(VListItemTitle, [
                    _vm._v(
                      "\n          " + _vm._s(menuItem.label) + "\n        "
                    ),
                  ]),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }